import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: "auto",
        loop: false,
        navigation: {
            nextEl: `.swiper-button-next-${sliderIdentifier}`,
            prevEl: `.swiper-button-prev-${sliderIdentifier}`
        },
        scrollbar: {
            el: `.swiper-scrollbar-${sliderIdentifier}`,
            draggable: true,
        }
    });
}

const allSliders = $('.process-slider.swiper-container');

allSliders.each((index, element) => buildSwiperSlider(element));
